import { useEffect, useState } from "react";
import { Megaphone, X } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function CampaignBanner() {
  const { user } = useAuth();
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    if (!user) { setCampaigns([]); return; }
    api.get("/campaigns/active").then(({ data }) => setCampaigns(data.campaigns || [])).catch(() => {});
  }, [user]);

  const dismiss = async (id) => {
    setCampaigns((cs) => cs.filter((c) => c.id !== id));
    try {
      await api.post(`/campaigns/${id}/dismiss`);
    } catch { /* best-effort */ }
  };

  if (!campaigns.length) return null;

  return (
    <div className="space-y-2" data-testid="campaign-banners">
      {campaigns.map((c) => (
        <div key={c.id} data-testid={`campaign-banner-${c.id}`}
          className="flex items-center gap-3 rounded-2xl border border-amber-500/30 bg-gradient-to-r from-amber-500/[0.12] to-transparent px-4 py-3">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-amber-500/15 text-amber-400">
            <Megaphone className="h-4 w-4" />
          </span>
          <div className="min-w-0 flex-1">
            <p className="truncate text-xs font-bold text-1" data-testid={`campaign-banner-title-${c.id}`}>{c.title}</p>
            <p className="truncate text-[11px] text-2">{c.message}</p>
          </div>
          <button onClick={() => dismiss(c.id)} data-testid={`campaign-banner-dismiss-${c.id}`} aria-label="Dismiss"
            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-line text-3 transition-colors hover:border-amber-500/40 hover:text-amber-400">
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ))}
    </div>
  );
}
